import React, { useEffect } from 'react';
import SectionTitle from '../../property-partners-portal/components/SectionTitle/SectionTitle';
import { useAccountInformation } from '../../contexts/AccountInformationContext';
import CardPlaceholder from '../components/CardPlaceholder';
import ReadOnlyView from './ReadOnlyView';
import EditView from './EditView';
import '../../stylesheets/presentationCards.scss';
import GoBackHomeLink from '../GoBackHomeLink';
import { ProfileViewMode } from '../../types/profile/profileTypes';
import Button from '../../muiComponents/Button';
import useTranslate from '../../customHooks/useTranslate';
import useUserProfile from '../../customHooks/useUserProfile';

const ContactsContainer = () => {
    const translate = useTranslate();
    const { readOnlyUser } = useUserProfile();
    const {
        viewMode,
        isLoadingAccountInformation,
        handleViewModeChange,
        handleDetailContact,
    } = useAccountInformation();

    useEffect(() => {
        return () => handleViewModeChange(ProfileViewMode.READ_ONLY);
    }, [handleViewModeChange]);

    const handleAddContactClick = () => {
        handleViewModeChange(ProfileViewMode.EDIT);
        handleDetailContact();
    };

    return (
        <div className='contacts__container'>
            <div className='flex-column gap-5'>
                <div className='page-title__container'>
                    <SectionTitle title={'contacts'} />

                    <GoBackHomeLink loading={isLoadingAccountInformation} />
                </div>

                {viewMode === ProfileViewMode.READ_ONLY && !readOnlyUser && (
                    <div className='flex flex-end'>
                        <Button
                            size='small'
                            variant='contained'
                            startIcon='Add'
                            onClick={handleAddContactClick}
                            disabled={isLoadingAccountInformation}
                        >
                            {translate('add_contact')}
                        </Button>
                    </div>
                )}
            </div>
            {isLoadingAccountInformation ? (
                <CardPlaceholder height='500px' />
            ) : (
                <>
                    {viewMode === ProfileViewMode.READ_ONLY ? (
                        <ReadOnlyView />
                    ) : (
                        <EditView />
                    )}
                </>
            )}
        </div>
    );
};

export default ContactsContainer;
